import React from "react";
import {
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Checkbox,
  ListItemText,
  Paper,
  Grid,
  Button,
  FormControlLabel,
  Box,
  Divider,
  Typography,
} from "@mui/material";
import MissionLogStyles from "../../../styles/MissionLog.module.css";

const MissionLogFilter = ({
  sortOrder,
  setSortOrder,
  setStatusFilter,
  statusFilter,
  onStatusFilterChange,
  includeNoAuths,
  onIncludeNoAuthsChange,
}) => {

  const handleStatusChange = (event) => {
    const { value } = event.target;
    setStatusFilter(value); // Updates the array of selected statuses
    onStatusFilterChange(value); // Call the handler function to apply the status filter
  };

  const handleSelectAll = () => {
    setStatusFilter(statuses);
    onStatusFilterChange(statuses);
  };

  const handleDeselectAll = () => {
    setStatusFilter([]);
    onStatusFilterChange([]);
  };

  const statuses = [
    "Authorized",
    "Pending",
    "Rescinded Awaiting",
    "De-authorized",
    "Complete",
    "Deleted",
    "Never Authorized",
    "Invalid Detected",
  ];

  return (
    <Paper className={MissionLogStyles.filterContainer}>
      <Grid container spacing={2} alignItems="center">

        <Grid item xs={12} sm={6} md={6} lg={2.5}>
          <FormControl fullWidth size="small" className={MissionLogStyles.selectContainer}>
            <InputLabel className={MissionLogStyles.selectLabel}>Sort By</InputLabel>
            <Select
              fullWidth
              value={sortOrder}
              onChange={(e) => setSortOrder(e.target.value)}
              label="Sort By"
              className={MissionLogStyles.selectInput}
              slotProps={{ textField: { size: "small" } }}
            >
              <MenuItem value="desc">Sort by Start Time (Newest First)</MenuItem>
              <MenuItem value="asc">Sort by Start Time (Oldest First)</MenuItem>
            </Select>
          </FormControl>
        </Grid>

        <Grid item xs={12} sm={12} md={12} lg={3}>
          <FormControl fullWidth size="small" className={MissionLogStyles.selectContainer}>
            <InputLabel className={MissionLogStyles.selectLabel}>Filter by Status</InputLabel>
            <Select
              multiple
              fullWidth
              value={statusFilter}
              onChange={handleStatusChange}
              renderValue={(selected) =>
                selected.length === 0 ? "None selected" :
                  selected.length === statuses.length ? "All selected" :
                    `${selected.length} selected`
              }
              MenuProps={{
                PaperProps: { style: { maxHeight: 300 } },
                autoFocus: false
              }}
            >
              {/* Select All / Deselect All Buttons */}
              <Box sx={{ px: 2, py: 1, display: 'flex', gap: 1 }}>
                <Button
                  size="small"
                  variant="outlined"
                  onClick={handleSelectAll}
                  fullWidth
                  sx={{ textTransform: 'none' }}
                >
                  Select All
                </Button>
                <Button
                  size="small"
                  variant="outlined"
                  onClick={handleDeselectAll}
                  fullWidth
                  sx={{ textTransform: 'none' }}
                >
                  Deselect All
                </Button>
              </Box>
              <Divider />

              {statuses.map((status) => (
                <MenuItem key={status} value={status}>
                  <Checkbox checked={statusFilter.includes(status)} />
                  <ListItemText primary={status} />
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>

        {/* Separate checkbox for operations without authorizations */}
        <Grid item xs={12} sm={12} md={12} lg={12}>
          <FormControlLabel
            control={
              <Checkbox
                checked={includeNoAuths}
                onChange={(e) => onIncludeNoAuthsChange(e.target.checked)}
                size="small"
              />
            }
            label={
              <Typography variant="body2" color="textSecondary" sx={{ fontSize: { xs: '0.813rem', sm: '0.875rem' } }}>
                Include operations without authorizations (uncontrolled airspace)
              </Typography>
            }
          />
        </Grid>
      </Grid>
    </Paper>
  );
};

export default MissionLogFilter;
